import { render, staticRenderFns } from "./dept-form.vue?vue&type=template&id=84fb9648"
import script from "./dept-form.vue?vue&type=script&lang=js"
export * from "./dept-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84fb9648')) {
      api.createRecord('84fb9648', component.options)
    } else {
      api.reload('84fb9648', component.options)
    }
    module.hot.accept("./dept-form.vue?vue&type=template&id=84fb9648", function () {
      api.rerender('84fb9648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/dept/dept-form.vue"
export default component.exports